var _path, _circle, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSavedQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.191 0H4.81C1.77 0 0 1.78 0 4.83V15.16C0 18.26 1.77 20 4.81 20H11.2547C10.4638 18.8662 10 17.4872 10 16C10 15.7672 10.0114 15.537 10.0336 15.31H5.08C4.78 15.35 4.49 15.2 4.33 14.95C4.17 14.69 4.17 14.36 4.33 14.11C4.49 13.85 4.78 13.71 5.08 13.74H10.3729C10.7718 12.5697 11.4721 11.5389 12.3812 10.74H5.08C4.649 10.74 4.3 10.39 4.3 9.96C4.3 9.53 4.649 9.179 5.08 9.179H12.92C13.306 9.179 13.6276 9.46188 13.6893 9.83085C14.675 9.30075 15.8024 9 17 9C17.3395 9 17.6734 9.02417 18 9.07089V4.83C18 1.78 16.28 0 13.191 0ZM5.08 4.65V4.66C4.649 4.66 4.3 5.01 4.3 5.44C4.3 5.87 4.649 6.22 5.08 6.22H8.069C8.5 6.22 8.85 5.87 8.85 5.429C8.85 5 8.5 4.65 8.069 4.65H5.08Z",
    fill: "#8A65A9"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 16,
    r: 6.25,
    stroke: "#8A65A9",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1989 11.926H16.7129V12.529C15.7049 12.628 14.7689 13.312 14.7689 14.383C14.7689 15.571 15.6599 15.949 16.6679 16.228L16.7129 16.237V18.136C16.2179 18.091 15.7229 17.875 15.4349 17.47L14.6159 18.307C15.1649 18.883 15.9299 19.117 16.7129 19.108V19.747H17.1989V19.099C18.3419 18.982 19.2599 18.316 19.2599 17.128C19.2599 15.895 18.2429 15.571 17.2349 15.301L17.1989 15.292V13.492C17.6129 13.492 18.0179 13.681 18.2969 13.978L19.0439 13.141C18.5849 12.736 17.8919 12.52 17.2799 12.52H17.1989V11.926ZM16.7129 15.157C16.2809 14.968 15.9029 14.878 15.9029 14.329C15.9029 13.87 16.2899 13.582 16.7129 13.51V15.157ZM17.1989 16.381C17.6219 16.525 18.1259 16.678 18.1259 17.209C18.1259 17.74 17.6939 18.037 17.1989 18.136V16.381Z",
    fill: "#8A65A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavedQuotes);
export default __webpack_public_path__ + "static/media/saved-quotes.c5c5529f67e125a3182f269fd1842432.svg";
export { ForwardRef as ReactComponent };